module.exports = __webpack_public_path__ + "static/media/Slide15.8ab9809f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slides/Slide15.png
// module id = 1637
// module chunks = 0